export const ENV = (process.env.NEXT_PUBLIC_APP_ENV || 'dev') as
  | 'prod'
  | 'stg'
  | 'dev'
  | 'local';
